import {
    FETCH_USERS_REQUEST,
    FETCH_USERS_SUCCESS,
    FETCH_USERS_FAILURE,
    APPEND_USERS_REQUEST,
    APPEND_USERS_SUCCESS,
    APPEND_USERS_FAILURE,
    FETCH_USER_REQUEST,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILURE,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    FETCH_INVITATIONS_REQUEST,
    FETCH_INVITATIONS_SUCCESS,
    FETCH_INVITATIONS_FAILURE,
    INVITE_USER_REQUEST,
    INVITE_USER_SUCCESS,
    INVITE_USER_FAILURE,
    DELETE_INVITATION_REQUEST,
    DELETE_INVITATION_SUCCESS,
    DELETE_INVITATION_FAILURE,
    CLEAR_USER_ERRORS
  } from '../actions/userActions';

  // État initial
  const initialState = {
    users: null,
    user: null,
    invitations: [],
    loading: false,
    loadingMore: false,
    hasMore: false,
    error: null
  };
  
  // Reducer
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_USERS_REQUEST:
      case FETCH_USER_REQUEST:
      case CREATE_USER_REQUEST:
      case UPDATE_USER_REQUEST:
      case DELETE_USER_REQUEST:
      case FETCH_INVITATIONS_REQUEST:
      case INVITE_USER_REQUEST:
      case DELETE_INVITATION_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_USERS_SUCCESS:
        return {
          ...state,
          users: action.payload,
          loading: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_USERS_REQUEST:
        return { ...state, loadingMore: true, error: null };

      case APPEND_USERS_SUCCESS:
        return {
          ...state,
          users: {
            ...action.payload,
            items: [...(state.users?.items || []), ...action.payload.items]
          },
          loadingMore: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_USERS_FAILURE:
        return { ...state, loadingMore: false, error: action.payload };
      
      case FETCH_USER_SUCCESS:
        return {
          ...state,
          user: action.payload || null,
          loading: false,
          error: null
        };
      
      case CREATE_USER_SUCCESS:
        return {
          ...state,
          users: state.users ? {
            ...state.users,
            items: [action.payload, ...(state.users.items || [])]
          } : state.users,
          loading: false,
          error: null
        };
      
      case UPDATE_USER_SUCCESS:
        return {
          ...state,
          users: state.users ? {
            ...state.users,
            items: state.users.items?.map(user =>
              user.id === action.payload.id ? action.payload : user
            )
          } : state.users,
          user: action.payload,
          loading: false,
          error: null
        };
      
      case DELETE_USER_SUCCESS:
        return {
          ...state,
          users: state.users ? {
            ...state.users,
            items: state.users.items?.filter(user => user.id !== action.payload)
          } : state.users,
          loading: false,
          error: null
        };
      
      case FETCH_INVITATIONS_SUCCESS:
        return {
          ...state,
          invitations: action.payload,
          loading: false,
          error: null
        };
      
      case INVITE_USER_SUCCESS:
        return {
          ...state,
          invitations: [...state.invitations, action.payload],
          loading: false,
          error: null
        };
      
      case DELETE_INVITATION_SUCCESS:
        return {
          ...state,
          invitations: state.invitations.filter(
            invitation => invitation.id !== action.payload
          ),
          loading: false,
          error: null
        };
      
      case FETCH_USERS_FAILURE:
      case FETCH_USER_FAILURE:
      case CREATE_USER_FAILURE:
      case UPDATE_USER_FAILURE:
      case DELETE_USER_FAILURE:
      case FETCH_INVITATIONS_FAILURE:
      case INVITE_USER_FAILURE:
      case DELETE_INVITATION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      case CLEAR_USER_ERRORS:
        return {
          ...state,
          error: null
        };
      
      default:
        return state;
    }
  };
  
  export default userReducer;